import { useId } from "react";
import type { SubMenuGroup } from "@/lib/config/navigationConfig";
import { useAppAccess } from "@/hooks/useAppAccess";
import { ErpSidebarSubItem } from "./ErpSidebarSubItem";

interface ErpSidebarSubGroupProps {
  group: SubMenuGroup;
  activeSubItemHref: string | undefined;
}

export function ErpSidebarSubGroup({
  group,
  activeSubItemHref,
}: ErpSidebarSubGroupProps) {
  const groupId = useId();
  const { isAdmin } = useAppAccess();

  const visibleItems = group.items.filter(
    (item) => !item.adminOnly || isAdmin
  );

  if (visibleItems.length === 0) return null;

  return (
    <div role="region" aria-labelledby={groupId}>
      <div
        id={groupId}
        className="pl-4 pr-2 pt-4 pb-1.5 text-[11px] font-medium text-[#0F0F10]/45 dark:text-gray-500 uppercase tracking-wider"
      >
        {group.title}
      </div>
      <div className="space-y-1">
        {visibleItems.map((subItem) => (
          <ErpSidebarSubItem
            key={`${subItem.href}-${subItem.name}`}
            subItem={subItem}
            isActive={activeSubItemHref === subItem.href}
          />
        ))}
      </div>
    </div>
  );
}
